import script from "./SectionTabView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionTabView.vue?vue&type=script&setup=true&lang=ts"

import "./SectionTabView.vue?vue&type=style&index=0&id=1200f5ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1200f5ff"]])

export default __exports__